const sectionsToRender = [
  {
    id: '#cart-counter',
    section: 'cart-counter',
    selector: '#shopify-section-cart-counter'
  },
  {
    id: '#CartDrawer-Body',
    section: 'cart-drawer',
    selector: '#shopify-section-cart-drawer #CartDrawer-Body'
  }
];

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'keyup',
      event => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.querySelector('#CartDrawer-Overlay').addEventListener(
      'click',
      this.close.bind(this)
    );
    this.setCartLink();
    this.parentElement.addEventListener(
      'shopify:section:select',
      () => this.open()
    );
    this.parentElement.addEventListener(
      'shopify:section:deselect',
      () => this.close()
    );
  }

  setCartLink() {
    const cartLink = document.querySelector('[data-cart-link]');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', event => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', event => {
      if (event.code.toUpperCase() !== 'SPACE') return;
      event.preventDefault();
      this.open(cartLink);
    });
  }

  open(opener) {
    if (opener) this.setActiveElement(opener);
    this.classList.add('is-visible');
    this.addEventListener(
      'transitionend',
      () => {
        this.focusOnCartDrawer();
      },
      { once: true }
    );
    this.lockScroll();
  }

  // Re-applies the mobile scroll lock to the current scrollable element.
  // Needed not just on open(), but also whenever cart-drawer-items
  // re-renders its markup (e.g. after removing/updating a line item),
  // since that replaces the [data-cart-scrollable] node and the previous
  // element no longer has the scroll-lock touch listeners attached to it.
  lockScroll() {
    const scrollLockTarget = this.querySelector('[data-cart-scrollable]') || this.querySelector('[role="dialog"]');
    if (this.scrollLockTarget && this.scrollLockTarget !== scrollLockTarget) {
      bodyScroll.unlock(this.scrollLockTarget);
    }
    this.scrollLockTarget = scrollLockTarget;
    bodyScroll.lock(scrollLockTarget);
  }

  close() {
    this.classList.remove('is-visible');
    removeTrapFocus(this.activeElement);

    const isHeaderMenuOpen = header.classList.contains('menu-open');

    if (isHeaderMenuOpen) {
      return;
    }

    if (this.scrollLockTarget) {
      bodyScroll.unlock(this.scrollLockTarget);
      this.scrollLockTarget = null;
    }

    // if we are on the cart page, resubmit form
    if (window.location.pathname === '/cart') {
      const cartDrawerForm = document.getElementById('CartDrawer-FormSummary');
      if (cartDrawerForm) {
        cartDrawerForm.submit();
      }
    }

  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  focusOnCartDrawer() {
    const containerToTrapFocusOn = this.firstElementChild;
    const focusElement = this.querySelector('[data-drawer-close]');
    trapFocus(containerToTrapFocusOn, focusElement);
  }

  renderContents(response, open = true) {
    this.getSectionsToRender()?.forEach(section => {
      const sectionElement = document.querySelector(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        response.sections[section.section],
        section.selector
      );
    });
    if (!open) {
      return;
    }

    this.open();
  }

  getSectionsToRender() {
    return sectionsToRender;
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return sectionsToRender;
  }

  updateQuantity(line, quantity, name) {
    // Capture the <cart-drawer> reference *before* the update runs: the base
    // updateQuantity() replaces #CartDrawer-Body's innerHTML, which is an
    // ancestor of this element, so `this` ends up detached from the DOM by
    // the time the fetch resolves and this.closest('cart-drawer') would
    // otherwise return null.
    const cartDrawer = this.closest('cart-drawer');
    return super.updateQuantity(line, quantity, name).then(() => {
      if (cartDrawer?.classList.contains('is-visible')) {
        cartDrawer.lockScroll();
      }
    });
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
